import { createTheme } from "@mui/material/styles";
import { ruRU } from "@mui/material/locale";

export const customTheme = createTheme(
  {
    components: {
      MuiButton: {
        styleOverrides: {
          sizeSmall: {
            padding: "4px 16px",
            fontSize: "14px",
            textTransform: "none",
          },
          sizeMedium: {
            padding: "8px 16px",
            fontSize: "15px",
            textTransform: "none",
          },
          sizeLarge: {
            padding: "12px 16px",
            fontSize: "16px",
            textTransform: "none",
          },
        },
      },
    },
    palette: {
      primary: {
        main: "#153D36",
        contrastText: "#fff",
      },
      secondary: {
        main: "#F36326",
        contrastText: "#fff",
      },

      customColors: {
        primary: "#153D36",
        accent: "#F36326",
        white: "#F5FAFC",
        danger: "#FA3A4D",
        warning: "#FF8800",

        labelsPrimary: "hsla(0, 0%, 0%, 1)",
        labelsSecondary: "hsla(240, 6%, 25%, 0.6)",
        labelsTertiary: "hsla(240, 6%, 25%, 0.3)",
        labelsQuaternary: "hsla(240, 6%, 25%, 0.18)",
      },
    },
  },
  ruRU,
);
